module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-text.7515b173.png";